import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const calendarsApiRoutes = {
    list: apiDataManagerBaseURL + "calendars/",
};

export class CalendarAPI {
    static list() {
        const url = calendarsApiRoutes.list;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/CalendarAPI.js